// @flow
import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Button, Cell } from '@gandi/ui';
import { ListRow, ListItem, ListStatus } from '@gandi/ui/deprecated';

import styles from './FilterFailedRow.scss';

type Props = {
  onClickResetFilter: (e: SyntheticMouseEvent<>) => void,
  translator: TranslatorProps,
};

function FilterFailedRow({ onClickResetFilter, translator: { __ } }: Props) {
  return (
    <ListRow marginBottom="base">
      <ListItem highlight="info">
        <ListStatus theme="info" />
        <Cell paddingLeft={null}>
          <span className={styles.paddingRight}>
            {__('No domains match your filter.')}
          </span>
          <Button kind="link" type="button" onClick={onClickResetFilter}>
            {__('Reset Filters')}
          </Button>
        </Cell>
      </ListItem>
    </ListRow>
  );
}

export default (React.memo<Props>(FilterFailedRow): React.ComponentType<Props>);
